<template>
  <div class="axa-box-general first">
    <div class="box-heading">
      <h2 class="heading">Arama Bilgileri</h2>
    </div>
    <div class="box-content">
      <v-tabs v-model="tab">
        <v-tab href="#tab-policy">Poliçe Listesi</v-tab>
        <v-tab href="#tab-guarantee">Teminat Oranlar</v-tab>
        <v-tab href="#tab-mail">Mail Girdileri</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item value="tab-policy">
          <v-data-table
            v-model="secilenPoliceler"
            :headers="polHeaders"
            :items="policeler"
            class="pol-table"
            dense
            :search="search"
            show-select
            item-key="cari_pol_no"
          >
            <template #top>
              <v-card-actions class="">
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-text-field
                  label="Poliçe Ara"
                  type="text"
                  prepend-icon="mdi-select-search"
                  v-model="search"
                  dense
                  hide-details
                />
              </v-card-actions>
            </template>
            <template #item.baslama_tarih="{ item }">
              {{ new Date(item.baslama_tarih.substr(0, 10).split('/').reverse().join('-')) | dateFormat }}/{{
                new Date(item.bitis_tarih.substr(0, 10).split('/').reverse().join('-')) | dateFormat
              }}
            </template>
          </v-data-table>
          <br />
        </v-tab-item>
        <v-tab-item value="tab-guarantee">
          <v-data-table :headers="temHeaders" :items="teminatlar" class="pol-table" dense>
            <template #[`item.value`]="{ item }"
              ><v-text-field outlined dense hide-details type="number" v-model="item.value"
            /></template>
          </v-data-table>
        </v-tab-item>
        <v-tab-item value="tab-mail">
          <v-icon @click="emails.push('')" flat>mdi-plus</v-icon>
          <div v-for="(item, i) in emails" :key="i">
            <v-text-field
              v-model="emails[i]"
              dense
              :label="'Mail' + (i + 1)"
              prepend-icon="mdi-at"
              :append-icon="i > 0 ? 'mdi-minus' : null"
              @click:append="i > 0 ? emails.splice(i, 1) : null"
              :rules="[v => !!v || 'Mail zorunludur.']"
            ></v-text-field>
          </div>
        </v-tab-item>
      </v-tabs-items>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="$emit('save', { secilenPoliceler, teminatlar, emails })" :disabled="secilenPoliceler.length < 1"
          >Kaydet</v-btn
        >
      </v-card-actions>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    policeler: {
      type: Array,
      default: () => [],
    },
    teminatlar: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      tab: null,
      polHeaders: [
        {
          text: 'Poliçe No',
          value: 'cari_pol_no',
        },
        {
          text: 'Tarife Kodu',
          value: 'tarife_kod',
        },
        {
          text: 'Başlama/Bitiş Tarihi',
          value: 'baslama_tarih',
        },
        {
          text: 'Sigortalı Ad/Soyad',
          value: 'must_ad_unvan',
        },
      ],
      temHeaders: [
        {
          text: 'Teminat Kodu',
          value: 'name',
        },
        {
          text: 'Teminat Adı',
          value: 'description',
        },
        {
          text: 'Oran %',
          value: 'value',
        },
      ],
      search: '',
      secilenPoliceler: [],
      emails: [''],
    };
  },
  methods: {
    secilenPolice(val, item) {
      if (item.checked) {
        const { _i, ...data } = item;
        this.secilenPoliceler.push(data);
      } else
        this.secilenPoliceler.splice(
          this.secilenPoliceler.indexOf(x => x.cari_pol_no == item.cari_pol_no),
          1,
        );
    },
    tumunuSec(val) {
      for (var i = 0; i < this.policeler.length; i++) {
        this.policeler[i].checked = val.target.checked;
        this.secilenPolice(null, this.policeler[i]);
      }
    },
  },
  filters: {
    dateFormat(val) {
      console.log(val.getDate());
      return `${val.getDate() < 10 ? '0' + val.getDate() : val.getDate()}.${
        val.getMonth() + 1 < 10 ? '0' + (val.getMonth() + 1) : val.getMonth() + 1
      }.${val.getFullYear()}`;
    },
  },
};
</script>
<style scoped></style>
